import React from 'react';

const MarqueeSection = () => {
  // Все логотипы в одну строку, без KLVLX, AUTOPROFI и дубликатов
  const allLogos = [
    '/images/letters/logos/TERMINUS.webp',
    '/images/letters/logos/Wirquin.webp',
    '/images/letters/logos/ZITREK.webp',
    '/images/letters/logos/DobroStroy.webp',
    '/images/letters/logos/Unikom.webp',
    '/images/letters/logos/GW.webp',
    '/images/letters/logos/Letta.webp',
    '/images/letters/logos/NR.webp',
    '/images/letters/logos/OBI.webp',
    '/images/letters/logos/REDsolution.webp',
    '/images/letters/logos/Resanta.webp',
    '/images/letters/logos/REXANT.webp',
    '/images/letters/logos/VirkenRus.webp',
  ];

  // Дублируем массив 4 раза для более плавной бесшовной прокрутки
  const repeated = [...allLogos, ...allLogos, ...allLogos, ...allLogos];

  return (
    <>
      <style>{`
        @keyframes marqueeScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-25%);
          }
        }

        @media (max-width: 768px) {
          .marquee-section { padding: 30px 0 !important; }
          .marquee-track { gap: 30px !important; }
          .marquee-logo { height: 50px !important; max-width: 180px !important; }
        }

        @media (max-width: 480px) {
          .marquee-section { padding: 20px 0 !important; }
          .marquee-track { gap: 20px !important; }
          .marquee-logo { height: 40px !important; max-width: 140px !important; }
        }
      `}</style>

      <section
        className="marquee-section"
        style={{
          background: '#0F0F1A',
          padding: '60px 0',
          overflow: 'hidden',
        }}
      >
        <div
          className="marquee-track"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '50px',
            animation: 'marqueeScroll 40s linear infinite',
            width: 'max-content',
          }}
        >
          {repeated.map((logo, i) => (
            <img
                loading="lazy"
              key={i}
              src={logo}
              alt=""
              className="marquee-logo"
              style={{
                height: '80px',
                width: 'auto',
                maxWidth: '300px',
                objectFit: 'contain',
                opacity: 0.5,
                filter: 'grayscale(100%) brightness(2)',
                transition: 'opacity 0.3s',
                flexShrink: 0,
              }}
              onMouseEnter={(e) => e.target.style.opacity = '0.8'}
              onMouseLeave={(e) => e.target.style.opacity = '0.5'}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default MarqueeSection;
